import React from "react"
import L10n from "lib/carrot-l10n"
import { FeatureGate } from "../../../../utils/FeatureGate"
import { Spacer } from "../../atoms/Atoms"
import { NavSection } from "./NavSection"
import { NavItem } from "./NavItem"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

export const YourJourneyNav = ({ onClick }) => (
  <NavSection iconName="icn-journey" sectionLabel={l`client.yourJourney`}>
    <FeatureGate filter={(c) => c.isLibraryEnabled}>
      <NavItem id="nav-library-link" link={"/read"} text={l`client.library.navText`} onClick={onClick} />
      <Spacer height={1} />
    </FeatureGate>
    <NavItem id="nav-provider-finder-link" link={"/providerfinder"} text={l`providerFinder`} onClick={onClick} />
  </NavSection>
)
